// import BlankLayout from 'components/Layout/blank';
import { IRouteProps } from "components/Router/Router";
import { HOMEPAGE_ROUTE } from "constants/router";
import MainLayout from "Layouts/main/index";
import React from "react";
import { Redirect, Route } from "react-router-dom";

const PrivateRoute: React.FC<IRouteProps> = ({
  component: Component,
  layout,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        true ? (
          layout === "main" ? (
            <MainLayout>
              <Component {...props} />
              
            </MainLayout>
          ) : (
            <>
              <Component {...props} />
            </>
          )
        ) : (
          <Redirect
            to={{
              pathname: HOMEPAGE_ROUTE,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
